import { RadioInput } from './RadioInputManager'
import { FileInput } from './FileInputManager'
import { Select } from './SelectManager'
import { validateInput } from '../utils/form'

interface FormManagerOptions {
  // validate is true: validate all input and select
  // validate is a list of string: validate input and select
  //   with [name] attributes corresponding to values of list
  validate?: boolean | string[]
}

export default class FormManager {
  options: FormManagerOptions

  constructor (options: FormManagerOptions = {}) {
    this.options = options
  }

  init (): void {
    const textContainers: NodeListOf<HTMLElement> = document.querySelectorAll('.nfb-form__text-container--simple, .nfb-form__text-container--multiple')
    const selectElements: NodeListOf<HTMLElement> = document.querySelectorAll('[data-ui-el="nfb-form-select-trigger"]')
    const radioContainers: NodeListOf<HTMLElement> = document.querySelectorAll('[data-ui-el="nfb-form-radio-trigger"]')
    const fileElements: NodeListOf<HTMLElement> = document.querySelectorAll('[data-ui-el="nfb-form-file-trigger"]')

    textContainers.forEach((container) => {
      const textInput = container.querySelector('.nfb-form__text--simple, .nfb-form__text--multiple') as HTMLElement
      const shouldValidate = this.shouldValidateElement(textInput)

      textInput?.addEventListener('input', function (this: any) {
        if (container.dataset.inputIsActive === 'false') {
          container.dataset.inputIsActive = 'true'
        }
        if (shouldValidate) {
          validateInput(textInput as HTMLInputElement)
        }
      })
      textInput?.addEventListener('blur', function (this: any) {
        if (container.dataset.inputIsActive === 'true') {
          container.dataset.inputIsActive = 'false'
        }
      })
    })

    radioContainers.forEach((element) => { (() => new RadioInput(element))() })
    selectElements.forEach((element) => { (() => new Select(element, { validate: this.shouldValidateElement(element) }))() })
    fileElements.forEach((element) => ((() => new FileInput(element))()))
  }

  shouldValidateElement = (element: HTMLElement): boolean => {
    const nameAttribute = element.hasAttribute('name')
      ? element.getAttribute('name')
      : element.querySelector('[name]')?.getAttribute('name')

    return this.options.validate === true ||
      (Array.isArray(this.options.validate) &&
      !!nameAttribute && this.options.validate.includes(nameAttribute))
  }
}
